import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import deTexts from './TradingDe.json';
import enTexts from './TradingEn.json';
import styles from './Trading.module.css';
import tradingImg from './images/Trading.png';
import portfolioImg from './images/Portfolio.png';

const Trading = () => {
    const {i18n} = useTranslation();
    const currentLang = i18n.language;
    const texts = currentLang.startsWith('de') ? deTexts : enTexts;

    const images = [tradingImg, portfolioImg];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handlePrev = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div className={styles.trading} id="trading">
            <div className={styles.content}>
                <div className={styles.imageWrapper}>
                    <div className={styles.slider}>
                        <button
                            className={styles.arrowLeft}
                            onClick={handlePrev}
                            aria-label="Vorheriges Bild">
                            ◀
                        </button>
                        <img
                            src={images[currentImageIndex]}
                            alt={`Bild ${currentImageIndex + 1}`}
                            className={styles.image}
                        />
                        <button
                            className={styles.arrowRight}
                            onClick={handleNext}
                            aria-label="Nächstes Bild">
                            ▶
                        </button>
                    </div>
                    <div className={styles.indicator}>
                        {currentImageIndex + 1}/{images.length}
                    </div>
                </div>
                <div className={styles.description}>
                    <h2>{texts.title || 'Trading'}</h2>
                    <p>{texts.description}</p>
                </div>
            </div>
        </div>
    );
};

export default Trading;
